<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100" align="left">
        <md-card style="margin-top: 0">
          <md-card-header>
            <h4 style="margin-top: 0.5rem;" class="title">INBOX</h4>
            <div style="width: 100%; border-bottom: 2px solid #0b6c8d!important;" />
          </md-card-header>

          <md-card-content :style="messages.length ? 'overflow: auto; height: 75vh;padding: 0;border-top: solid 1px #eee' : 'overflow: auto; height: 75vh;padding: 0;'">
            <div
              v-for="(message, index) in messages"
              :key="index"
              :class="[
                { alert: true },
                { 'alert-selected': message.isSelected }
            ]"
              @click="selectMessage(message.ID)"
            >
              <!-- <button type="button" aria-hidden="true" class="close">×</button> -->
              <span style="font-size: .85rem;font-weight: 500;">{{ message.Subject }}</span>
              <span style="font-size: .75rem;">{{ message.formattedDateShort }}</span>
              
            </div>
            <div v-if="!isLoading && !messages.length" style="text-align: center;">
              No messages found
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-70 md-small-size-100" align="left">
        <md-card style="margin-top: 0">
          <md-card-header>
            <h4 style="margin-top: 0.5rem;" class="title">MESSAGE</h4>
            <div style="width: 100%; border-bottom: 2px solid #0b6c8d!important;" />
          </md-card-header>
          <md-card-content style="height: 75vh;overflow: auto;padding: 0;">
            <md-card v-if="msg" style="margin: 0;box-shadow: none;">
              <md-card-header>
                <div align="left">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">Date: </span>
                  <span style="font-size: .9rem;">{{ msg.formattedDateLong }}</span>
                </div>
                <div align="left">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">From: </span>
                  <span style="font-size: .9rem;">{{ msg.Sender }}</span>
                </div>
                <div align="left" style="padding-bottom: 0.5rem;border-bottom: solid 1px #eee;">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">Subject: </span>
                  <span style="font-size: .9rem;">{{ msg.Subject }}</span>
                </div>
              </md-card-header>
              <md-card-content style="overflow: auto; height: 55vh;">
                <span v-html="msg.Body" />
              </md-card-content>
              <md-card-actions />
            </md-card>
            <div v-if="!msg && messages.length" style="text-align: center;">
              Select a message
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <loader :is-visible="isLoading" />
  </div>
</template>

<script>

import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  components: {
    loader
  },
  data() {
    return {
      route: "/msg/msgs-in/",
      messages: [],
      isLoading: false,
      msg: null
    }
  },
  computed: {
    msgSender() {
      if (this.msg) {
        return this.msg.Sender
      } else {
        return ""
      }
    },
    msgSubject() {
      if (this.msg) {
        return this.msg.Subject
      } else {
        return ""
      }
    },
    msgDate() {
      if (this.msg) {
        return this.msg.MsgDate
      } else {
        return ""
      }
    },
    msgBody() {
      if (this.msg) {
        return this.msg.Body
      } else {
        return ""
      }
    }
  },
  created: function() {},
  mounted: function() {
    this.getMessages()
  },
  methods: {
    async getMessages() {
      this.isLoading = true;
      const url = process.env.VUE_APP_URL + this.route + sessionStorage.getItem("username")
      const config = {
        headers: {
          "Content-Type": "application/json" /*'Access-Control-Allow-Origin': '*', */
        }
      }
      const data = null

      var vm = this
      await window.axios
        .get(url, data, config, { useCache: false })
        .then(r => r.data)
        .then(msgs => {
          this.messages = msgs.map(i=>{
            i.formattedDateShort = i.MsgDate ? moment(i.MsgDate).format('ll') : ''
            i.formattedDateLong = i.MsgDate ? moment(i.MsgDate).format('llll')  :''
            return i;
          })
          this.messages.sort((a,b) => a.MsgDate < b.MsgDate ? 1 : -1);
        }).finally(()=>{
          this.isLoading = false;
        })
    },
    selectMessage(id) {
      for (const m of this.messages) {
        m.isSelected = false;
      }
      this.msg = this.messages.find(m => m.ID == id)
      if (this.msg) {
        this.msg.isSelected = true;
      }
    }
  }
}
</script>

<style lang="css" scoped>

.alert-selected {
  background-color: #0287d6 !important;
  color: #fff !important;
}

.alert{
  background: white;
  color: #000;
  border-top: solid 1px #eee;
  border-bottom: solid 1px #eee;
  box-shadow: none;
  border-radius: 0;
  margin-top: -1px;
  margin-bottom: 0;
  padding: 20px 20px;
}
</style>
